import React from "react";
import PropTypes from "prop-types";

var ListboxGroup = function ListboxGroup(_ref) {
  var label = _ref.label,
      children = _ref.children,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLabel && /*#__PURE__*/React.createElement("li", {
    className: "et-listbox--item-group"
  }, label), /*#__PURE__*/React.createElement("ul", null, children));
};

ListboxGroup.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  showLabel: PropTypes.bool
};
export default ListboxGroup;